import type { ReactNode, TextareaHTMLAttributes } from "react";
import Field from "../Field/Field";
import "./TextArea.css";

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode | boolean;
  className?: string;
}

/**
 * Multi-line text with the label above.
 * Example: <TextArea id="note" label="Note" rows={4} value={v} onChange={fn} />
 */
const TextArea = ({
  id,
  label,
  hint,
  error,
  className = "",
  rows = 4,
  ...textareaProps
}: TextAreaProps) => (
  <Field
    htmlFor={id}
    label={label}
    hint={hint}
    error={error as ReactNode}
    className={className}
  >
    <textarea
      id={id}
      rows={rows}
      className="ds-control ds-textarea"
      aria-invalid={error ? true : undefined}
      {...textareaProps}
    />
  </Field>
);

export default TextArea;
